import cn from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import messages from "./go-to-account-link-messages";

import "./go-to-account-link.scss";

const GoToAccountLink = props => {
  const myAccountPath = `/user${props.queryString}`;

  return (
    <Link
      className={cn("go-to-account-link", props.className)}
      to={myAccountPath}
    >
      <FormattedMessage {...messages.goToMyAccount} />
    </Link>
  );
};

GoToAccountLink.propTypes = {
  className: PropTypes.string,
  queryString: PropTypes.string.isRequired
};

GoToAccountLink.defaultProps = {
  className: ""
};

const mapStateToProps = state => ({
  queryString: state.router.location.search
});

export { GoToAccountLink };
export default connect(mapStateToProps)(GoToAccountLink);
